module.exports = __webpack_public_path__ + "5b5fa5d37287effae982baea288581d6.gif";